module.exports = __webpack_public_path__ + "img/moon.220cbf59.svg";